<template>
    <div>
        <div v-if="integrations.length > 0" class="mt-10 grid grid-cols-2 gap-6 tablet:gap-4 mobile:grid-cols-2 mobile:gap-2">
            <integration-tile v-for="integration in integrations" :integration="integration" :key="integration.link"></integration-tile>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import IntegrationTile from "./components/tile.vue";
import {Integration} from "./types";

export default defineComponent({
    name: "marketplace-liza",
    components: {IntegrationTile},
    data() {
        return {
            integrations: (window.cw.integrations || []) as Integration[]
        }
    }
})
</script>